import PageComponent from '../../common/component/page-component';


class ProductsOverview extends PageComponent {

	constructor({
		root,
		element,
		tagAttribute = 'tag',
		categoryAttribute = 'category',
		productTagsAttribute = 'productTags',
		categoriesAttribute = 'categories',
		selectedClass = 'selected',
		activeClass = 'active',
		inactiveClass = 'inactive',
		hiddenClass = 'hidden'
	}) {
		super({root: root, element: element});
		this.tagAttribute = tagAttribute;
		this.categoryAttribute = categoryAttribute;
		this.productTagsAttribute = productTagsAttribute;
		this.categoriesAttribute = categoriesAttribute;
		this.selectedClass = selectedClass;
		this.activeClass = activeClass;
		this.inactiveClass = inactiveClass;
		this.hiddenClass =hiddenClass;
		this.tags = new Map();
		this.categories = new Map();
		this.selectedTag = null;
		this.allTag = null;
		this.busy = false;
	}


	injectHistory(history) {
		this.history = history;
	}


	prepare() {
		this.getComponents('AsyncPicture').map((img) => img.setSurviveDetached(true));
		this.categoriesElement = this.element.querySelector(this.dataSelector(this.categoriesAttribute));
		const tags = this.element.querySelectorAll(this.dataSelector(this.tagAttribute));
		if (tags.length) {
			for (const tag of tags) {
				const tagValue = this.dataAttr(tag).get(this.tagAttribute);
				if (tagValue === '') {
					this.allTag = tag;
				}
				this.tags.set(tag, tagValue);
				if (this.classList(tag).contains(this.selectedClass)) {
					this.selectedTag = tag;
				}
			}

			const categories = this.element.querySelectorAll(this.dataSelector(this.categoryAttribute));
			for (const category of categories) {
				const productsMap = new Map();
				const products = category.querySelectorAll(this.dataSelector(this.productTagsAttribute));
				for (const product of products) {
					productsMap.set(product, this.dataAttr(product).get(this.productTagsAttribute));
				}
				this.categories.set(category, productsMap);
			}
			this.listeners.tagClick = this.events.on(this.element, this.dataSelector(this.tagAttribute), 'click', this.onToggleTag.bind(this));
			this.update(false);
		}
	}


	clear() {
		this.getComponents('AsyncPicture').map((img) => img.setSurviveDetached(false));
	}


	onToggleTag(event, target) {
		if (!this.busy) {
			if (target === this.selectedTag) {
				const tagValue = this.dataAttr(target).get(this.tagAttribute);
				if (tagValue !==  '') {
					this.selectedTag = this.allTag;
					this.classList(target).toggle(this.selectedClass);
					this.classList(this.allTag).toggle(this.selectedClass);
					this.update();
				}
			} else {
				if (this.selectedTag !== null) {
					this.classList(this.selectedTag).remove(this.selectedClass);
				}
				this.selectedTag = target;
				this.classList(target).toggle(this.selectedClass);
				this.update();
			}
		}
	}


	update(animate = true) {
		if (this.busy) {
			return;
		}
		this.busy = true;
		let promise = Promise.resolve();
		const categoriesClassList = this.classList(this.categoriesElement);
		if (animate) {
			promise = promise.then(() => {
				categoriesClassList.add(this.hiddenClass);
				return this.onTransitionEnd(this.categoriesElement);
			});
		}
		promise = promise.then(() => {
			const tagValue = this.selectedTag ? this.tags.get(this.selectedTag) : null;
			for (const [category, products] of this.categories) {
				let activeCount = 0;
				for (const [product, productTags] of products) {
					const active = (tagValue === null || tagValue === '' || productTags.indexOf(tagValue) >= 0);
					this.classList(product).toggle(this.activeClass, active);
					if (active) {
						activeCount++;
					}
				}
				this.classList(category).toggle(this.inactiveClass, activeCount === 0);
			}
			if (this.history.isSupported()) {
				this.history.replace(location.origin + location.pathname + (tagValue && tagValue.length ? '?' + this.tagAttribute + '=' + tagValue : ''));
			}
			return Promise.resolve();
		});
		if (animate) {
			promise = promise.then(() => {
				categoriesClassList.remove(this.hiddenClass);
				return this.onTransitionEnd(this.categoriesElement);
			});
		}
		promise.then(() => {
			this.busy = false;
		});
	}

}


export default ProductsOverview;
